import { ancillaryConnectionService } from "../../../services/connections/ancillaryService";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import {
  AncillaryConnection,
  AncillaryConnectionFilters,
} from "../../../types/ancillary";
import useAncillaryLogic from "../../logic/connections/ancillaryLogic";
import useConnectionQueryClient from "./connectionQueryClient";

const useAncillaryQuery = () => {
  const { defaultAncillary, getDisplayName } = useAncillaryLogic(null, null);
  return useConnectionQueryClient<
    AncillaryConnection,
    AncillaryConnectionFilters
  >({
    service: ancillaryConnectionService,
    collection: SystemEntityCollections.ANCILLARY,
    defaultConnection: defaultAncillary,
    snackbarDisplayName: getDisplayName,
  });
};

export default useAncillaryQuery;
